import { gsap } from 'gsap';

export function sliderInit(el) {
  const container = el.querySelector('.slider__container');
  const arrowLeft = el.querySelector('.slider__arrow--left');
  const firstImage = el.querySelector('.slider__item');
  const arrowsRight = el.querySelector('.slider__arrow--right');
  const name = el.querySelector('.slider__name');

  gsap.set(container, { scale: 0, transformOrigin: '50% 50%' });
  gsap.set(arrowLeft, { opacity: 0, x: 20 });
  gsap.set(arrowsRight, { opacity: 0, x: -20 });
  gsap.set(firstImage, { opacity: 0 });
  gsap.set(name, { opacity: 0, yPercent: 30 });
}

export function sliderEnter(el) {
  const container = el.querySelector('.slider__container');
  const arrowLeft = el.querySelector('.slider__arrow--left');
  const arrowsRight = el.querySelector('.slider__arrow--right');
  const firstImage = el.querySelector('.slider__item');
  const name = el.querySelector('.slider__name');
  const tl = gsap.timeline();

  tl.addLabel('start')
    .to(container, {
      scale: 1,
      ease: 'bloom',
      duration: 1.5,
    }, 'start')
    .to(name, {
      opacity: 1,
      ease: 'bloom',
    }, 'start+=2')
    .to(arrowLeft, {
      opacity: 1,
      x: 0,
      ease: 'bloom',
    }, 'start+=0.8')
    .to(arrowsRight, {
      opacity: 1,
      x: 0,
      ease: 'bloom',
    }, 'start+=0.8')
    .to(firstImage, {
      opacity: 1,
      ease: 'bloom',
    }, 'start+=1')
    .to(name, {
      opacity: 1,
      yPercent: 18,
      ease: 'bloom',
      duration: 1.5,
    }, 'start+=1');

  return tl;
}

export function sliderLeave(el) {
  el.removeAttribute('data-animated');
  const tl = gsap.timeline();

  tl.addLabel('start')
    .to(el, {
      scale: 0.8,
      opacity: 0,
      ease: 'bloom',
    }, 'start');

  return tl;
}
